import { useEffect } from 'react';
import { useAppSelector } from '../app/hooks';
import { selectIsModifierQuantityEnabled } from '../redux/features/config/config.selector';
import { setModifierCountRuleActive } from '../utils/modifierQuantity';

/**
 * HITL-1762 — mirrors the modifier-count gate into the cart utilities. Group
 * validation (`isInvalidModGroup`) is called from places with no store, so it
 * reads the gate from `modifierQuantity.ts` rather than from a selector.
 */
const useModifierCountRule = () => {
  const isModifierQuantityEnabled = useAppSelector(
    selectIsModifierQuantityEnabled
  );
  useEffect(() => {
    setModifierCountRuleActive(isModifierQuantityEnabled);
  }, [isModifierQuantityEnabled]);
};

export default useModifierCountRule;
